var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.768,
    height: 19.374,
    viewBox: "13.116 11.313 15.768 19.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-user-7174673"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.001 11.313a4.15 4.15 0 0 1 3.007 1.303 4.493 4.493 0 0 1 1.236 3.114 4.493 4.493 0 0 1-1.236 3.113 4.148 4.148 0 0 1-3.007 1.303 4.15 4.15 0 0 1-3.007-1.303 4.493 4.493 0 0 1-1.235-3.113c0-1.215.471-2.316 1.235-3.114A4.148 4.148 0 0 1 21 11.313Z",
    fill: "#a87cee",
    fillRule: "evenodd",
    "data-name": "Path 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.772 29.696a24.03 24.03 0 0 1-6.771.99v.001c-2.255 0-4.511-.33-6.771-.991a1.542 1.542 0 0 1-1.094-1.73 7.96 7.96 0 0 1 2.707-4.794A7.932 7.932 0 0 1 21 21.276c1.967 0 3.767.713 5.157 1.896a7.96 7.96 0 0 1 2.707 4.795 1.545 1.545 0 0 1-1.094 1.729h.002Z",
    fill: "#a87cee",
    fillRule: "evenodd",
    "data-name": "Path 52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user_white.21ec2f761e5d1f4f86fec2535d3f3e05.svg";
export { ForwardRef as ReactComponent };